// @flow
const PREFIX_CAMERA = `hive/camera/`;

export const UPDATE_CAMERA_SETTINGS = `${PREFIX_CAMERA}UPDATE_CAMERA_SETTINGS`;
export const CAMERA_SETTINGS_UPDATED = `${PREFIX_CAMERA}CAMERA_SETTINGS_UPDATED`;



// WEBPACK FOOTER //
// ./src/core/state/camera/constants.js